function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "7"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd401",
  fillOpacity: ".54",
  fillRule: "evenodd",
  d: "M.512 4.2A.674.674 0 01.5 3.229a.725.725 0 011.008.008L3.571 5.22 8.5.482a.735.735 0 011-.002c.276.265.271.7-.004.966l-5.2 4.999c-.4.385-1.054.38-1.447.002L.512 4.2z"
})));